import { Link } from 'react-router-dom';

import { BRANDING } from '@perplexicon/config';

import { assetUrl } from '../assets/asset-manifest.js';

export interface BrandProps {
  compact?: boolean;
  onNavigate?: () => void;
}

/** Brand text remains selectable HTML; the replaceable mark is decorative beside it. */
export function Brand({ compact = false, onNavigate }: BrandProps) {
  return (
    <Link
      to="/"
      onClick={onNavigate}
      aria-label={`${BRANDING.appName} home`}
      className="group inline-flex min-h-touch items-center gap-2 rounded-md text-textOnDark"
    >
      <img
        src={assetUrl('brandMark')}
        width={40}
        height={40}
        alt=""
        aria-hidden="true"
        className="h-9 w-9 shrink-0 rounded-md shadow-2 tablet:h-10 tablet:w-10"
      />
      <span className={`brand-type ${compact ? 'text-base' : 'text-lg tablet:text-xl'}`}>
        {BRANDING.appName}
      </span>
    </Link>
  );
}
